module.exports = __webpack_public_path__ + "media/images/flags/HM-d95ca43d4ad8c6a7cfef9c8b8f810efc.svg";